module.exports = __webpack_public_path__ + "img/logo-light-mono-tagline.a7f383de.svg";